/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The status of the event. Possible values: 'confirmed' (event is confirmed), 'cancelled' (event has been cancelled), 'tentative' (event is tentative)
 */
export type ListEventSeriesResponseInputDataItemEventsItemStatus =
  (typeof ListEventSeriesResponseInputDataItemEventsItemStatus)[keyof typeof ListEventSeriesResponseInputDataItemEventsItemStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListEventSeriesResponseInputDataItemEventsItemStatus = {
  confirmed: "confirmed",
  cancelled: "cancelled",
  tentative: "tentative"
} as const
